import React, { useState } from "react"
import "register/less/registration.less"
import Field from "shared/components/forms/field"
import Button from 'shared/components/button'
import { register } from "../apicalls/api-calls"
import { useTranslation } from 'react-i18next'
import { generateNewCaptchaToken } from "../helper/captcha"
import { isWarningEmail } from "../helper/registration"
import ReactTooltip from "react-tooltip"

const EnterEmailComponent = (props) => {

    const [email, setEmail] = useState(props.email)
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [warningEmail, setWarningEmail] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [isButtonLoading, setIsButtonLoading] = useState(false)
    const { t } = useTranslation()

    const registerUser = () => {
        if (email == undefined || email.length == 0) {
            setErrorMessage(t('invalid_email.register'))
            setInvalidEmail(true)
        } else if (!validateEmail(email)) {
            setErrorMessage(t('form.invalid_email'))
            setInvalidEmail(true)
        } else {
            setInvalidEmail(false)
            setIsButtonLoading(true)
            props.setEmail(email)
            const properties = {
                email: email,
                referredId: parseInt(props.referredId),
                languageId: props.languageId,
                referrerDescription: props.referrerDescription,
                responderTypeId: props.responderTypeId,
                token: props.token,
                url: props.url,
                src: parseInt(props.src),
            }
            generateNewCaptchaToken((recaptchaToken) => {
                register(properties, t, recaptchaToken,
                    (message) => setError(message), (result) => setSuccess(result))
            })
        }
    }

    const setSuccess = (result) => {
        props.setRegistrationData(result)
        setIsButtonLoading(false)
    }

    const setError = (message) => {
        setInvalidEmail(true)
        setIsButtonLoading(false)
        setErrorMessage(message)
    }

    const validateEmail = (enteredEmail) => {
        return String(enteredEmail)
            .toLowerCase()
            .match(
                /^\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}\s*$/
            )
    }

    const validateWarningEmails = (enteredEmail) => {
        const isWarning = isWarningEmail(enteredEmail)
        if(invalidEmail){
            const isValid = validateEmail(enteredEmail)
            setInvalidEmail(isValid)
        }
        setWarningEmail(isWarning)
    }

    const getEmailClass = () => {
        let classes = "input-choice-first-step-email"
        if (invalidEmail) {
            classes = `${classes} input-choice-error`
        }
        if(warningEmail && !invalidEmail){
            classes = `${classes} input-choice-warning`
        }
        return classes
    }

    const handleKeypress = e => {
        if (e.key === 'Enter') {
            registerUser()
        }
    }

    return (
        <div className="email-container">
            <label htmlFor="email" className="basic-label">
                {t("user.email_address")}
                <span className="label-italic"> {`(${t("user.email.personal_recommended")})`} </span>
            </label>
            <div>
                <Field
                    placeholder="name@domain.com"
                    type="basic"
                    className={getEmailClass()}
                    id="email"
                    value={email}
                    onKeyPress={handleKeypress}
                    onChange={({ target: { value } }) => {
                        setEmail(value)
                        validateWarningEmails(value)
                    }}
                />
                {warningEmail && !invalidEmail &&
                    <div className="warning-div">
                        <i className="im-check im-warning input-warning-icon" data-tip={t("user.email.personal_recommended_description")}/>
                        <ReactTooltip type="dark" effect="solid"/>
                        <i className="im-check im-Answered-Survey input-waring-icon-correct"/>
                    </div>
                }
            </div>
            {invalidEmail &&
                <div>
                    <div className='error-message'>
                        {errorMessage == "" ? t('form.invalid_email') : errorMessage}
                    </div>
                </div>
            }
            <div className="line-2" />

            <div>
                <Button name="Submit Email Button" type="submit" className="btn-register" onClick={registerUser} isLoading={isButtonLoading}>
                    {t('form.register_now')}
                </Button>
            </div>

        </div>

    )
}
export default EnterEmailComponent